"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeLifecycleJSONModelFromQueryString = exports.LifecyclePageModelProvider = exports.useLifecyclePageModelContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const query_string_1 = __importDefault(require("query-string"));
const LifecycleJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/model/LifecycleJSONModel");
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const react_router_dom_1 = require("react-router-dom");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const STATE_QUERY_KEY = "state";
const LifecyclePageModelContext = React.createContext(undefined);
const useLifecyclePageModelContext = () => {
    const context = React.useContext(LifecyclePageModelContext);
    if (!context) {
        throw new Error("useLifecyclePageModelContext must be used within a LifecyclePageModelContext.Provider");
    }
    return context;
};
exports.useLifecyclePageModelContext = useLifecyclePageModelContext;
const LifecyclePageModelProvider = (props) => {
    const isMounted = (0, isMounted_1.default)();
    const { projectApiKey } = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const [pageModelFormState, setPageModelFormState] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), (0, exports.deserializeLifecycleJSONModelFromQueryString)(location.search).serialize());
    ////////////////////////////////////////////////
    // Update page model on page URL change
    ////////////////////////////////////////////////
    (0, use_custom_compare_1.useCustomCompareEffect)(() => {
        if (isMounted()) {
            const jsonModel = (0, exports.deserializeLifecycleJSONModelFromQueryString)(location.search);
            setPageModelFormState(jsonModel.serialize());
        }
    }, [projectApiKey, location.search, isMounted], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Get Form JSON Model
    ////////////////////////////////////////////////
    const getFormJSONModel = (0, use_custom_compare_1.useCustomCompareCallback)(() => {
        return new LifecycleJSONModel_1.LifecycleJSONModel(pageModelFormState);
    }, [pageModelFormState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // On Period Changed
    ////////////////////////////////////////////////
    const onPeriodChanged = (0, use_custom_compare_1.useCustomCompareCallback)((last) => {
        const jsonModel = new LifecycleJSONModel_1.LifecycleJSONModel(pageModelFormState);
        jsonModel.getPeriodDaysJSONModel().setLast(last);
        const serializedState = jsonModel.serialize();
        setPageModelFormState(serializedState);
    }, [pageModelFormState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // On Granularity Changed
    ////////////////////////////////////////////////
    const onGranularityChanged = (0, use_custom_compare_1.useCustomCompareCallback)((granularity) => {
        const jsonModel = new LifecycleJSONModel_1.LifecycleJSONModel(pageModelFormState);
        jsonModel.getGranularityJSONModel().setGranularity(granularity);
        const serializedState = jsonModel.serialize();
        setPageModelFormState(serializedState);
    }, [pageModelFormState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Show action
    ////////////////////////////////////////////////
    const show = (0, use_custom_compare_1.useCustomCompareCallback)(() => {
        if (isMounted()) {
            //model from location query
            const modelFromLocationQuery = (0, exports.deserializeLifecycleJSONModelFromQueryString)(location.search);
            //passed model from UI
            const jsonModel = new LifecycleJSONModel_1.LifecycleJSONModel(pageModelFormState);
            //compare if there are differences
            const isEqualState = lodash_1.default.isEqual(modelFromLocationQuery.serialize(), jsonModel.serialize());
            //bump sequence to redraw UI
            jsonModel.getSequenceJSONModel().bumpValue();
            const serializedState = LifecycleJSONModel_1.LifecycleJSONModel.makeModelStateClean(jsonModel.serialize());
            //generate new URL
            const newUrl = AppRouting_1.AppPathGenerator.Project.lifecycle(projectApiKey, serializedState);
            if (isEqualState) {
                history.replace(newUrl);
            }
            else {
                history.push(newUrl);
            }
        }
    }, [projectApiKey, pageModelFormState, location.search, isMounted], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Return value
    ////////////////////////////////////////////////
    const pageModelStateFns = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        getFormJSONModel,
        show,
        onPeriodChanged,
        onGranularityChanged,
    }), [getFormJSONModel, show, onPeriodChanged, onGranularityChanged], lodash_1.default.isEqual);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        pageModelFormState,
        pageModelStateFns,
    }), [
        pageModelFormState,
        pageModelStateFns,
    ], lodash_1.default.isEqual);
    return React.createElement(LifecyclePageModelContext.Provider, { value: value }, props.children);
};
exports.LifecyclePageModelProvider = LifecyclePageModelProvider;
const deserializeLifecycleJSONModelFromQueryString = (query) => {
    const queryParams = query_string_1.default.parse(query);
    const modelStateSerialized = queryParams[STATE_QUERY_KEY];
    const jsonModel = new LifecycleJSONModel_1.LifecycleJSONModel();
    jsonModel.overwriteFromSerializedStateString(modelStateSerialized);
    return jsonModel;
};
exports.deserializeLifecycleJSONModelFromQueryString = deserializeLifecycleJSONModelFromQueryString;
